import { useState, useCallback } from "react";
import { putTitleURL } from "../../utils/ConstantsURL";

export const useDocumentStyles = (token, documentId, initialStyles = {}) => {
  const [documentStyles, setDocumentStyles] = useState({
    title: initialStyles.title || {},
    logo: initialStyles.logo || {},
    index: initialStyles.index || {},
    footer: initialStyles.footer || {},
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateSection = useCallback((section, updates) => {
    setDocumentStyles((prev) => ({
      ...prev,
      [section]: { ...prev[section], ...updates },
    }));
  }, []);

  const updateTitleStyles = useCallback(
    async (titleStyles) => {
      if (!documentId) {
        setError("ID de documento requerido");
        return { success: false, error: "ID de documento requerido" };
      }
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(putTitleURL(documentId), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(titleStyles),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || `Error HTTP: ${response.status}`);
        }

        const data = await response.json();

        setDocumentStyles((prev) => ({
          ...prev,
          title: data,
        }));

        return { success: true, data };
      } catch (error) {
        const errorMessage =
          error.message || "Error al actualizar estilos del título";
        setError(errorMessage);
        console.error("Error actualizando estilos:", error);
        return { success: false, error: errorMessage };
      } finally {
        setLoading(false);
      }
    },
    [token, documentId]
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    documentStyles,
    loading,
    error,
    updateSection,
    updateTitleStyles,
    clearError,
    setDocumentStyles,
  };
};
